import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { AuthService } from '@nstep-common/core';

@Directive({
	selector: '[appAccessHider]',
	standalone: false
})
export class AcccessHiderDirective implements OnChanges {
	@Input('appAccessHider') permissions: string[] = [];
	@Input() fullAccessRequired: boolean = true;

	constructor(private el: ElementRef, private authService: AuthService) { }

	ngOnChanges() {
		const hide = this.fullAccessRequired
			? !this.authService.hasAccess(...this.permissions)
			: !this.authService.hasPartialAccess(...this.permissions);

		if (hide) {
			this.el.nativeElement.style.display = 'none';
		}
		else {
			this.el.nativeElement.style.display = '';
		}
	}
}